import { Injectable } from '@angular/core';
import { Store } from '@ngxs/store';
import { CommonService } from 'app/reusable/common.service';
import { SetSteps } from 'app/_actions/intake.actions';
import { CASE_DETAILS } from 'app/_constants/caseDetails';
import { INTAKE_STEPS } from 'app/_constants/intake-steps';
import { IntakeStepModel } from 'app/_models/intakestep.model';
import { CaseService } from './case.service';

@Injectable({
  providedIn: 'root'
})
export class StepService {



  constructor(private caseService: CaseService) { }


  async getStepswithMandatoryupdated(cause, steps){
    let setSteps: IntakeStepModel[] = [];
    for(let step of steps)
    {
      const isMendatory = await this.isStepMendatory(cause, step.step);
      setSteps.push({...step,isMendatory});
    }
    return setSteps;
  }

public async isStepMendatory(cause, stepId)
{
    switch (stepId) {
        
        case INTAKE_STEPS.POLICY:
            return true;
        case INTAKE_STEPS.INSUREE: 
            return true;
        case INTAKE_STEPS.CASE:
            return await this.isCasePageMendatory(cause);
        case INTAKE_STEPS.LOCATION: 
            return false;
        case INTAKE_STEPS.TRAVEL: 
            return true;
        case INTAKE_STEPS.PARTY: 
            return false;
        case INTAKE_STEPS.HELP_PLAN: 
            return false;
        case INTAKE_STEPS.SUMMARY: 
            return true;
        default:
            return true;
    }
}   
 public isCasePageMendatory= async (cause) =>
 {
    const causeDetailName= await this.caseService.getCauseDetailName(cause.ctyCaseDetailId);
    switch (causeDetailName) {
        case CASE_DETAILS.CALL_BACK:
            return true;
        case CASE_DETAILS.DEATH: 
            return true;
        case CASE_DETAILS.DIAGNOSES:
            return true;
        case CASE_DETAILS.GENERAL:
            return true;         
        default:
            return true;
    }
 }


enableNoneMandatorySteps(stepIndex: number,steps: IntakeStepModel[], store: Store)
{
    const stepArrayIndex = steps.findIndex(({step})=> step == stepIndex );

    const previousSteps =  steps.slice(0 , stepArrayIndex + 1 )
    const potentialStepsToEnable = steps.slice(stepArrayIndex + 1);

     let nextStep; 
     let i = 0
    do
     {
        nextStep = potentialStepsToEnable[i];
        if(nextStep.enabled)
             nextStep.isActive = true;
        i++;
     } while(!nextStep.enabled || (!nextStep.isMendatory && i<= potentialStepsToEnable.length) )

     
    store.dispatch(new SetSteps([...previousSteps,...potentialStepsToEnable]));
}


}

